module.exports = "<svg viewBox=\"0 0 16 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.49 10.896C14.617 12.06 16 14.304 16 17c0 4.056-2.916 7-6.934 7H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h8.066C12.45 0 15 2.58 15 6c0 2.05-.986 3.818-2.51 4.896zM14 17c0-2.47-1.707-4.97-4.97-4.97-.053 0-.1-.022-.153-.03H2v10h7.066C12.456 22 14 19.408 14 17zM9.066 2H2v8h7c2.28 0 4-1.72 4-4 0-2.318-1.654-4-3.934-4z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/scripts/components/shared/InlineEditor/images/bold.svg
// module id = jzIA
// module chunks = 89